const BASE_URL = 'https://europe-west3-hyper-e122e.cloudfunctions.net/get_users';
const WORKER_DETAIL_URL = 'https://europe-west3-hyper-e122e.cloudfunctions.net/get_user';
const SEARCH_BASE_URL = 'https://europe-west3-hyper-e122e.cloudfunctions.net';

import User from '../models/User.js';
import { getAuth } from 'firebase/auth';
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../utils/firebase";
import axios from 'axios';

class ConnectService {
  static nextId = null;
  static isLoading = false;

  static async waitForAuthUser() {
    return new Promise((resolve) => {
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        unsubscribe();
        resolve(user);
      });
    });
  }

  static async fetchWorkers(limit = 12, filters = {}) {
    if (this.isLoading) return [];
    this.isLoading = true;

    try {
      const user = await this.waitForAuthUser();
      if (!user) throw new Error("Пользователь не авторизован");

      const token = await user.getIdToken();

      console.log("📥 Получены фильтры:", filters);

      const params = new URLSearchParams();
      params.set("limit", limit);

      if (this.nextId) {
        params.set("last_id", this.nextId);
      }

      if (filters.isRemote === true) {
        params.set("is_remote", "true");
      }

      if (filters.isConsultant === true) {
        params.set("is_consultant", "true");
      }

      if (filters.created) {
        params.set("created", filters.created);
      }

      const url = `${BASE_URL}?${params.toString()}`;
      console.log("🌐 Итоговый URL запроса:", url);

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Ошибка загрузки: ${response.status}`);
      }

      const data = await response.json();
      this.nextId = data.next_id || null;

      console.log(`✅ Загружено ${data.workers?.length || 0} пользователей (next_id: ${this.nextId})`);
      return data.workers || [];
    } catch (error) {
      console.error('❌ Ошибка в fetchWorkers:', error);
      return [];
    } finally {
      this.isLoading = false;
    }
  }

  static resetPagination() {
    this.nextId = null;
  }

/**
 * Получение одного пользователя с полным профилем
 * @param {string} workerId — кого получаем
 * @param {boolean} isEmployer — является ли работодатель
 * @returns {Promise<Object|null>}
 */
static async fetchWorkerById(
  workerId,
  isEmployer = false
) {
  if (!workerId) {
    console.warn(
      "⚠️ Не указан workerId"
    );

    return null;
  }

  try {
    const user =
      await this.waitForAuthUser();

    if (!user) {
      console.warn(
        "❌ Пользователь не авторизован → редирект на стартовую"
      );

      window.location.replace(
        "https://hr3.space/"
      );

      return null;
    }

    const token =
      await user.getIdToken();

    const url =
      new URL(
        WORKER_DETAIL_URL
      );

    url.searchParams.set(
      "user_id",
      user.uid
    );

    url.searchParams.set(
      "worker_id",
      workerId
    );

    url.searchParams.set(
      "is_employer",
      isEmployer.toString()
    );

    console.log(
      "📡 Отправляем GET-запрос на:",
      url.toString()
    );

    const response =
      await fetch(
        url.toString(),
        {
          method: "GET",

          headers: {
            Authorization:
              `Bearer ${token}`,

            "Content-Type":
              "application/json"
          }
        }
      );

    /*
     * Если сервер считает токен невалидным
     * или сессия больше недействительна.
     */
    if (
      response.status === 401
    ) {
      console.warn(
        "❌ Авторизация истекла → редирект на стартовую"
      );

      window.location.replace(
        "https://hr3.space/"
      );

      return null;
    }

    if (!response.ok) {
      const errorText =
        await response.text();

      console.error(
        "❌ Ошибка API:",
        response.status,
        errorText
      );

      throw new Error(
        `Ошибка запроса: ${response.status}`
      );
    }

    const data =
      await response.json();

    return (
      data.worker ||
      null
    );
  } catch (error) {
    console.error(
      "❌ Ошибка fetchWorkerById:",
      error
    );

    return null;
  }
}

  static async searchUsers(query = "") {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      const token = await currentUser.getIdToken(true);
      if (!token) throw new Error("❌ Не удалось получить токен");

      const params = {};
      if (query && query.trim() !== "") {
        params.query = query.trim();
      }

      const response = await axios.get(`${SEARCH_BASE_URL}/search_users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      });

      const rawUsers = response.data.workers || [];
      const users = rawUsers.map((u) => new User(u));

      console.log(`✅ Получено ${users.length} пользователей`);
      return users;

    } catch (error) {
      console.error('🔴 Ошибка в searchUsers:', error.message || error);
      return [];
    }
  }

}

export default ConnectService;